var A = Object.defineProperty, T = Object.defineProperties;
var $ = Object.getOwnPropertyDescriptors;
var P = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var B = (s, e, t) => e in s ? A(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, y = (s, e) => {
  for (var t in e || (e = {}))
    N.call(e, t) && B(s, t, e[t]);
  if (P)
    for (var t of P(e))
      R.call(e, t) && B(s, t, e[t]);
  return s;
}, b = (s, e) => T(s, $(e));
var h = (s, e) => {
  var t = {};
  for (var r in s)
    N.call(s, r) && e.indexOf(r) < 0 && (t[r] = s[r]);
  if (s != null && P)
    for (var r of P(s))
      e.indexOf(r) < 0 && R.call(s, r) && (t[r] = s[r]);
  return t;
};
import { jsx as v } from "react/jsx-runtime";
import { useRef as k } from "react";
import { f as D, u as w, B as q } from "./factory-ueRxoNOV.js";
import { I as G } from "./InputBase-Cabx1d9o.js";
import { u as H, a as J } from "./Pill-s4XaUkmY.js";
import { u as K } from "./use-styles-DToiHEa6.js";
import { u as L } from "./Input--FNE961U.js";
import { u as O } from "./use-merged-ref-n551Tfbr.js";
var E = { field: "m_45c4369d" };
const Q = {
  type: "visible"
}, _ = D((s, e) => {
  const t = w("PillsInputField", Q, s), g = t, {
    classNames: r,
    className: n,
    style: d,
    styles: u,
    unstyled: p,
    vars: F,
    type: c,
    disabled: m,
    id: I,
    pointer: a,
    mod: f
  } = g, i = h(g, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "type",
    "disabled",
    "id",
    "pointer",
    "mod"
  ]), o = H(), l = L(), j = K({
    name: "PillsInputField",
    classes: E,
    props: t,
    className: n,
    style: d,
    classNames: r,
    styles: u,
    unstyled: p,
    rootSelector: "field"
  }), S = m || (o == null ? void 0 : o.disabled);
  return /* @__PURE__ */ v(
    q,
    b(y(y({
      component: "input",
      ref: O(e, o == null ? void 0 : o.fieldRef),
      "data-type": c,
      disabled: S,
      mod: [{ disabled: S, pointer: a }, f]
    }, j("field")), i), {
      id: (l == null ? void 0 : l.inputId) || I,
      "aria-invalid": o == null ? void 0 : o.hasError,
      "aria-describedby": l == null ? void 0 : l.describedBy,
      type: "text",
      onMouseDown: (z) => !a && z.stopPropagation()
    })
  );
});
_.classes = E;
_.displayName = "@mantine/core/PillsInputField";
const U = {}, M = D((s, e) => {
  const f = w("PillsInput", U, s), {
    children: r,
    onMouseDown: n,
    onClick: d,
    size: u,
    disabled: p,
    __staticSelector: F,
    error: c,
    variant: m
  } = f, I = h(f, [
    "children",
    "onMouseDown",
    "onClick",
    "size",
    "disabled",
    "__staticSelector",
    "error",
    "variant"
  ]), a = k(null);
  return /* @__PURE__ */ v(J, { value: { fieldRef: a, size: u, disabled: p, hasError: !!c, variant: m }, children: /* @__PURE__ */ v(
    G,
    b(y({
      size: u,
      error: c,
      variant: m,
      component: "div",
      ref: e,
      onMouseDown: (i) => {
        var o;
        i.preventDefault(), n == null || n(i), (o = a.current) == null || o.focus();
      },
      onClick: (i) => {
        var l;
        i.preventDefault();
        const o = i.currentTarget.closest("fieldset");
        o != null && o.disabled || ((l = a.current) == null || l.focus(), d == null || d(i));
      }
    }, I), {
      multiline: !0,
      disabled: p,
      __staticSelector: F || "PillsInput",
      withAria: !1,
      children: r
    })
  ) });
});
M.displayName = "@mantine/core/PillsInput";
M.Field = _;
export {
  M as P
};
